import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterDispatch } from '@state/matter';
import { TestHooks } from './effective-date.hooks';

@Component({
	selector: 'app-effective-date',
	templateUrl: './effective-date.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class EffectiveDateComponent {
	testHooks = TestHooks;
	@ViewSelectSnapshot(SelectedMatter.titleInsuranceEffectiveDate)
	effectiveDate: string;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	@Input() labelClass = '';

	constructor(private matterDispatch: MatterDispatch) {}

	setEffectiveDate(value: string): void {
		this.matterDispatch.SetTitleInsuranceEffectiveDate(this.matterId, value);
	}
}
